"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactResizeAware = _interopRequireDefault(require("react-resize-aware"));

var _SelectStyled = require("./Select-styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// App components
// Third-party components (buttons, icons, etc.)
// JSON
// CSS
var SelectMenu = function SelectMenu(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef,
      scheduleUpdate = _ref.scheduleUpdate,
      other = _objectWithoutProperties(_ref, ["children", "innerRef", "scheduleUpdate"]);

  var resizeReporter = function resizeReporter(target) {
    target && scheduleUpdate && scheduleUpdate();
  };

  var _useResizeAware = (0, _reactResizeAware.default)(resizeReporter),
      _useResizeAware2 = _slicedToArray(_useResizeAware, 1),
      resizeListener = _useResizeAware2[0];

  return _react.default.createElement(_SelectStyled.StyledSelectMenu, _extends({
    ref: innerRef
  }, other), resizeListener, children);
};

SelectMenu.propTypes = {
  /** Ref of the Popper wrapping this component */
  innerRef: _propTypes.default.func,

  /** Popper method to call when the component resizes */
  scheduleUpdate: _propTypes.default.func
};
SelectMenu.defaultProps = {};
var _default = SelectMenu;
exports.default = _default;